export default class EnquiryForm {
	constructor(form) {
		if (!form) return;

		this.formEl = form;
		this.inputs = [];
		this.invalidInputs = [];

		this.events();
		this.checkForCurrentHotel();
	}

	onFormResponse(ev) {
		const detail = ev.detail;
		this.inputs = detail.inputs;
		this.invalidInputs = detail.apiResponse?.invalid_fields;

		this.inputs.map((input) => {
			const field = this.formEl.querySelector(`[name="${input.name}"]`);
			field.setAttribute("aria-invalid", "false");
		});

		if (this.invalidInputs) {
			this.invalidInputs.map((input) => {
				const field = this.formEl.querySelector(`#${input.idref}`);
				field.setAttribute("aria-invalid", "true");
			});
		}
	}

	checkForCurrentHotel() {
		if (THEME_OBJ?.restaurant?.length > 0) {
			const enquirySelect = this.formEl.querySelector("select#enquiry-select");
			Array.from(enquirySelect.options).map((o, idx) => {
				if (o.value === THEME_OBJ.restaurant) {
					enquirySelect.options[idx].selected = true;
				}
			});
		} else if (THEME_OBJ?.position?.length > 0) {
			const positionSelect = this.formEl.querySelector(
				"select#position-select"
			);
			Array.from(positionSelect.options).map((o, idx) => {
				if (o.value === THEME_OBJ.position) {
					positionSelect.options[idx].selected = true;
				}
			});
		} else if (THEME_OBJ?.hotel_slug?.length > 0) {
			const enquirySelect = this.formEl.querySelector("select#enquiry-select");
			Array.from(enquirySelect.options).map((o, idx) => {
				if (o.value === THEME_OBJ.hotel_slug) {
					enquirySelect.options[idx].selected = true;
				}
			});
		}
	}

	events() {
		this.formEl.addEventListener(
			"wpcf7submit",
			this.onFormResponse.bind(this),
			false
		);
	}
}
